import tableNumberEnum from "@/model/tableNumberEnum";
import { operationsHelper } from "@/utils/operationsHelpers";
import TableTools from "@/utils/tableTools";
import i18n from "@/plugins/vue-i18n";
import { calculatedColumnsEnum, columnTypeEnum } from "@/model/columnsEnums";
import mesureEnum from "@/model/mesureEnum";
import dimensionEnum from "@/model/dimensionEnum";
import Vue from "vue";
import Tools from "@/utils/tools";
import { currencies } from "@/i18n";

export default {
	namespaced: true,
	state: {
		dataReadyTables1: false,
		dataReadyTables2: false,
		dataReadyTables3: false,
		tablesData: [],
		filters: [],
		timeDimension: null,
		siteValues: [],
		measureColumnsTable1: [],
		measureColumnsTable2: [],
		measureColumnsTable3: [],
		dimensionColmunTable2: [],
		groupHeadersTable1: [],
		groupHeadersTable2: [],
		groupHeadersTable3: [],
    isOmniplay: false,
	},
	mutations: {
		setMeasureColmunTable1(state, data){
			state.measureColumnsTable1 = data;
		},
		setGroupHeadersTable1(state, data){
			state.groupHeadersTable1 = data;
		},
		setDimensionColmunTable2(state, data){
			state.dimensionColmunTable2 = data;
		},
		setMeasureColmunTable2(state, data){
			state.measureColumnsTable2 = data;
		},
		setGroupHeadersTable2(state, data){
			state.groupHeadersTable2 = data;
		},
		setMeasureColmunTable3(state, data){
			state.measureColumnsTable3 = data;
		},
		setGroupHeadersTable3(state, data){
			state.groupHeadersTable3 = data;
		},
		setDataReadyTables1(state, data){
			state.dataReadyTables1 = data;
		},
		setDataReadyTables2(state, data){
			state.dataReadyTables2 = data;
		},
		setDataReadyTables3(state, data){
			state.dataReadyTables3 = data;
		},
		setFilters(state, data) {
			state.filters = data;
		},
		setTimeDimension(state, data) {
			state.timeDimension = data;
		},
		setSiteValues(state, data) {
			state.siteValues = data;
		},
		setTablesData(state, data) {
			state.tablesData = data
		},
		updateTableData1(state, payload){
       state.tablesData = state.tablesData.map((tabs) => {
        if (tabs.dataTable1.tableHeaderId === payload.siteId) {
          return {
            ...tabs,
            dataTable1 : {
              ...tabs.dataTable1,
              dataTable: payload.dataTable,
              dynamicMeasureColumnsTable: payload.dynamicMeasureColumnsTable
            },
          };
        }
        return tabs;
      });
    },
		updateTableData2(state, payload){
       state.tablesData = state.tablesData.map((tabs) => {
        if (tabs.dataTable1.tableHeaderId === payload.siteId) {
          return {
            ...tabs,
            dataTable2 : {
              ...tabs.dataTable2,
              dataTable: payload.dataTable,
              totalsData: payload.totalsData,
            },
          };
        }
        return tabs;
      });
    },
		updateTableData3(state, payload){
       state.tablesData = state.tablesData.map((tabs) => {
        if (tabs.dataTable1.tableHeaderId === payload.siteId) {
          return {
            ...tabs,
            dataTable3 : {
              ...tabs.dataTable3,
              dataTable: payload.dataTable,
              dynamicMeasureColumnsTable: payload.dynamicMeasureColumnsTable
            },
          };
        }
        return tabs;
      });
    },
    setIsOmniplay(state, data){
			state.isOmniplay = data;
		},
	},
	actions: {
		initDisplayTable1({commit, state}) {
      const measureColumnsTable1 = TableTools.Helper.constructColumnTable(
        [
          calculatedColumnsEnum.TOTAL_COLUMN,
          mesureEnum.PURCHASEHISTORY_COUNTSOLDCARDS,
          mesureEnum.PURCHASEHISTORY_AMOUNT,
          mesureEnum.SNACKHISTORY_AMOUNT_CB_TTC,
          ...(state.isOmniplay ? [mesureEnum.OMNIPLAYEVENT_TOTALTTC] : []),
          calculatedColumnsEnum.STAFF_CREDITED_TOKENS,
          mesureEnum.PURCHASEHISTORY_TOKEN,
          mesureEnum.PURCHASEHISTORY_BONUSTOKEN,
          calculatedColumnsEnum.PERCENT_BONUS_TOKEN,
        ],
        null,
        columnTypeEnum.MEASURE,
        true,
        null,
        false
      );

			commit('setMeasureColmunTable1', measureColumnsTable1);

      const nbOfMeasuresDirectPayment = state.isOmniplay ? 2 : 1;
      const groupHeadersTable1 = [
        { nbOfMeasures: 1 },
        { nbOfMeasures: 2 },
        { nbOfMeasures: nbOfMeasuresDirectPayment, label: i18n.t("group.revenueDirectPayment") },
        { nbOfMeasures: 4, label: i18n.t("group.creditedTokens") },
      ];

			commit('setGroupHeadersTable1', groupHeadersTable1);
    },

		initDisplayTable2({commit, state}) {
      // "Fausse dimension" : colonne qui sera en premier, avec "Total" écrit en footer
      const dimensionColumnsTable2 = TableTools.Helper.constructColumnTable(
        [calculatedColumnsEnum.SALE_CATEGORY],
        null,
        columnTypeEnum.DIMENSION,
        true,
        null
      );

			commit('setDimensionColmunTable2', dimensionColumnsTable2);

      // Autres colonnes dans l'ordre
      const measureColumnsTable2 = TableTools.Helper.constructColumnTable(
        [
          calculatedColumnsEnum.TAXES_PERCENTAGE,
          calculatedColumnsEnum.REVENUE_TTC,
          calculatedColumnsEnum.REVENUE_HT,
          calculatedColumnsEnum.REVENUE_TVA,
          calculatedColumnsEnum.TOKEN_QUANTITY,
          calculatedColumnsEnum.BONUS_TOKEN_QUANTITY,
          calculatedColumnsEnum.PERCENT_BONUS_TOKEN,
          calculatedColumnsEnum.PERCENT_PER_ACTIVITY,
        ],
        null,
        columnTypeEnum.MEASURE,
        true,
        null,
        false
      );

			commit('setMeasureColmunTable2', measureColumnsTable2);

      const groupHeadersTable2 = [
        { nbOfMeasures: 1 },
        { nbOfMeasures: 3, label: i18n.t("group.turnoverEquivalent") },
        { nbOfMeasures: 3, label: i18n.t("group.consumedTokens") },
        { nbOfMeasures: 1 },
      ];

			commit('setGroupHeadersTable2', groupHeadersTable2);
    },

		initDisplayTable3({commit}) {
      const measureColumnsTable3 = TableTools.Helper.constructColumnTable(
        [
          calculatedColumnsEnum.DIFF_PAYING_TOKENS,
          calculatedColumnsEnum.DIFF_BONUS_TOKENS,
          calculatedColumnsEnum.DIFF_ALL_TOKENS,
          calculatedColumnsEnum.PERCENT_TOKEN_NOT_CONSUMED,
          calculatedColumnsEnum.DIFF_REVENUE,
        ],
        null,
        columnTypeEnum.MEASURE,
        false,
        null,
        false,
      );

			commit('setMeasureColmunTable3', measureColumnsTable3);

      const groupHeadersTable3 = [
        { nbOfMeasures: 5, label: i18n.t("group.differenceCreditConsumed") },
      ];

			commit('setGroupHeadersTable3', groupHeadersTable3);
    },

		async initTablesData({commit, dispatch, state}) {
			let tablesData = state.siteValues.map((site, i) => {
				return {
					dataTable1 : {
							tableNumber: `${i}1`,
							tableHeader: site.label,
							tableHeaderId: site.id,
							dataTable: [],
              dynamicMeasureColumnsTable: null // since table headers have the site currency
					},
					dataTable2 : {
							tableNumber: `${i}2`,
							tableHeader: site.label,
							tableHeaderId: site.id,
							dataTable: [],
							totalsData : {}
					},
					dataTable3 : {
							tableNumber: `${i}3`,
							tableHeader: site.label,
							tableHeaderId: site.id,
							dataTable: [],
              dynamicMeasureColumnsTable: null // since table headers have the site currency
					}
				}
			});

			commit('setTablesData', tablesData);

			await dispatch('updateTables1')
			await dispatch('updateTables2')
			await dispatch('updateTables3')
		},

		updateTablesData({commit}, {tableNumber, siteId, dataTable, dynamicMeasureColumnsTable = null, totalsData = {}}){
			switch (tableNumber) {
        case tableNumberEnum.TABLE_ONE:
          commit('updateTableData1',
            {
              siteId: siteId,
              dataTable: dataTable,
              dynamicMeasureColumnsTable: dynamicMeasureColumnsTable
            });
          break;
        case tableNumberEnum.TABLE_TWO:
          commit('updateTableData2',
            {
              siteId: siteId,
              dataTable: dataTable,
              totalsData: totalsData
            });
          break;
        case tableNumberEnum.TABLE_THREE:
          commit('updateTableData3',
            {
              siteId: siteId,
              dataTable: dataTable,
              dynamicMeasureColumnsTable: dynamicMeasureColumnsTable
            });
          break;
        default:
          break;
      }
		},

		async updateTables1({commit, state, dispatch}){
      try {
        commit('setDataReadyTables1', false);
        commit('setDataReadyTables3', false);

				const birthdayFilter =
          TableTools.Helper.getFilterPurchaseHistoryNotBirthday();
        var purchaseHistoryFilters = [...state.filters];
        purchaseHistoryFilters.push(birthdayFilter);

        // relatif au rapport Omniplay
        const eventsFilters = state.isOmniplay ?
          operationsHelper.getOmniplayFilters(state.filters) :
          null;
        const eventTimeDimension = state.isOmniplay && state.timeDimension
          ? { ...state.timeDimension, dimension: dimensionEnum.OMNIPLAYEVENT_EVENTBUSINESSDATE }
          : null;

			let queries = operationsHelper.getQueriesTable1(state.filters, purchaseHistoryFilters, eventsFilters, state.timeDimension);

				// Injecter eventTimeDimension pour les queries event uniquement
				if (state.timeDimension && eventsFilters) {
					queries.forEach(q => {
						const isEventQuery = q.query.filters === eventsFilters;
						if (isEventQuery && eventTimeDimension) {
							q.query.timeDimensions = [eventTimeDimension];
						}
					});
				}
				var resultSets = await TableTools.Helper.doMultipleRequest(queries);
        var mergedResults = TableTools.Helper.mergeResultsByCommonDimensions(
          resultSets,
          operationsHelper.dimensionsTable1
        );

				mergedResults.map((table) => {

          // NB : éviter d'afficher 0 s'il n'y a aucun résultat
          const staffCardToken =
            table[mesureEnum.ADJUSTMENTHISTORY_TOKENCREDITED];
          const staffGameToken =
            table[mesureEnum.STAFFGAMEHISTORY_TOKENCREDITED];
          if (staffCardToken || staffGameToken) {
            table[calculatedColumnsEnum.STAFF_CREDITED_TOKENS] =
              (staffCardToken || 0) + (staffGameToken || 0);
          }

          if(state.isOmniplay){
            // Ajouter les tokens bonus des events aux tokens bonus des purchase history
            // pour avoir le vrai nombre de token bonus crédités
            const totalBonusToken = (table[mesureEnum.PURCHASEHISTORY_BONUSTOKEN] || 0) + (table[mesureEnum.OMNIPLAYEVENT_TOTAL_BONUS_TOKEN] || 0);
            table[mesureEnum.PURCHASEHISTORY_BONUSTOKEN] = totalBonusToken;
          }

          // Fausse donnée, pour afficher "Total" :
          table[calculatedColumnsEnum.TOTAL_COLUMN] = i18n.t(
            calculatedColumnsEnum.TOTAL_DATA
          );

          // Update des colonnes calculé "% unités payantes et bonus" :
          const totalUnitCredited =
            (table[mesureEnum.PURCHASEHISTORY_TOKEN] || 0) +
            (table[mesureEnum.PURCHASEHISTORY_BONUSTOKEN] || 0);
          const percentUnitBonusCredited =
            (table[mesureEnum.PURCHASEHISTORY_BONUSTOKEN] * 100) /
            totalUnitCredited;
          if (totalUnitCredited != 0) {
            table[calculatedColumnsEnum.PERCENT_BONUS_TOKEN] = percentUnitBonusCredited;
          }

          if(state.isOmniplay){
            // Add TVA for "Réservation internet" lines
            const amountTtc = mergedResults[calculatedColumnsEnum.REVENUE_TTC] || 0;
            const amountHt = mergedResults[calculatedColumnsEnum.REVENUE_HT] || 0;
            mergedResults[calculatedColumnsEnum.REVENUE_TVA] = amountTtc - amountHt;
          }

          return mergedResults;
        });

				state.siteValues.forEach(async (site) => {
          let datatable = mergedResults.filter(
            (result) => result[dimensionEnum.SITE] === site.id
          );

          let updatedMeasureColumnsTable1 = null;
          if(datatable.length > 0 && datatable[0][dimensionEnum.SITE_CURRENCY] != currencies["EUR"]){
            // here the site currency is not default EUROS
            // so we update this specific site's table header
            updatedMeasureColumnsTable1 = TableTools.Helper.updateCurrencyTableHeader(
              state.measureColumnsTable1,
              [mesureEnum.PURCHASEHISTORY_AMOUNT],
              datatable[0][dimensionEnum.SITE_CURRENCY]
            );
          }

					dispatch('updateTablesData', {
            tableNumber : tableNumberEnum.TABLE_ONE,
            siteId : site.id,
            dataTable : datatable,
            dynamicMeasureColumnsTable: updatedMeasureColumnsTable1
          });

					dispatch('initDisplayTable3');
        })

        commit('setDataReadyTables1', true);
      } catch (error) {
        Tools.Alerts.Error(Vue.swal, error)
      }
		},

		async updateTables2({state, commit, dispatch}){
      try {
				commit('setDataReadyTables2', false);
				commit('setDataReadyTables3', false);

        // relatif au rapport Omniplay
        const eventsFilters = state.isOmniplay ?
          operationsHelper.getOmniplayFilters(state.filters) :
          null;
        const eventTimeDimension = state.isOmniplay && state.timeDimension
          ? { ...state.timeDimension, dimension: dimensionEnum.OMNIPLAYEVENT_EVENTBUSINESSDATE }
          : null;

				const queries = operationsHelper.getQueriesTable2(state.filters, eventsFilters, state.timeDimension)
				// Injecter eventTimeDimension pour les queries event uniquement
				if (state.timeDimension && eventsFilters) {
					queries.forEach(q => {
						const isEventQuery = q.query.filters === eventsFilters;
						if (isEventQuery && eventTimeDimension) {
							q.query.timeDimensions = [eventTimeDimension];
						}
					});
				}
				let resultSets = await TableTools.Helper.doMultipleRequest(queries);
				let mergedResults = operationsHelper.mergeAndCompleteResultsTable2(resultSets, dimensionEnum.SITE_SITE_CATEGORY);

				state.siteValues.forEach(async (site) => {
          let datatable = mergedResults[site.id];

          const totals = TableTools.Helper.calculateTotalsData(
            datatable,
            [
              calculatedColumnsEnum.REVENUE_TTC,
              calculatedColumnsEnum.REVENUE_HT,
              calculatedColumnsEnum.REVENUE_TVA,
              calculatedColumnsEnum.TOKEN_QUANTITY,
              calculatedColumnsEnum.PERCENT_BONUS_TOKEN,
              calculatedColumnsEnum.BONUS_TOKEN_QUANTITY,
              mesureEnum.SNACKHISTORY_AMOUNT_CB_TTC,
              calculatedColumnsEnum.PERCENT_PER_ACTIVITY,
            ]
          );

          // Pourcentages unités consommées totaux
          const sumTotalsPercent =
            totals[calculatedColumnsEnum.TOKEN_QUANTITY] +
            totals[calculatedColumnsEnum.BONUS_TOKEN_QUANTITY];
          totals[calculatedColumnsEnum.PERCENT_BONUS_TOKEN] =
            (totals[calculatedColumnsEnum.BONUS_TOKEN_QUANTITY] * 100) /
            sumTotalsPercent;

					dispatch('updateTablesData', {
            tableNumber : tableNumberEnum.TABLE_TWO,
            siteId : site.id,
            dataTable : datatable,
            totalsData : totals
          });
        })

        commit('setDataReadyTables2', true)
      } catch (error) {
        Tools.Alerts.Error(Vue.swal, error)
      }
		},

		updateTables3({state, commit, dispatch}) {
      try {
        commit('setDataReadyTables3', false);

        state.siteValues.forEach(async (site) => {
          let dataTable = {};
          const table = state.tablesData.find((x) => {
            return x.dataTable1?.tableHeaderId == site.id;
          });

          const data1 =
            table.dataTable1 && table.dataTable1?.dataTable?.length ? table.dataTable1.dataTable[0] : {};
            const data2 =
            table.dataTable2 && table.dataTable2?.dataTable?.length ? table.dataTable2.dataTable[0] : {};

          const totals2 = table.dataTable2.totalsData || {};

          // we are manually adding the currency in the datatable
          // because we do not make any cube request here
          dataTable[dimensionEnum.SITE_CURRENCY] = data1[dimensionEnum.SITE_CURRENCY] || data2[dimensionEnum.SITE_CURRENCY];

          dataTable[calculatedColumnsEnum.DIFF_PAYING_TOKENS] =
            (data1[mesureEnum.PURCHASEHISTORY_TOKEN] || 0) -
            (totals2[calculatedColumnsEnum.TOKEN_QUANTITY] || 0);

          dataTable[calculatedColumnsEnum.PERCENT_TOKEN_NOT_CONSUMED] =
            (dataTable[calculatedColumnsEnum.DIFF_PAYING_TOKENS]) /
            (data1[mesureEnum.PURCHASEHISTORY_TOKEN] || 1)
            * 100;

          dataTable[calculatedColumnsEnum.DIFF_BONUS_TOKENS] =
            (data1[mesureEnum.PURCHASEHISTORY_BONUSTOKEN] || 0) -
            (totals2[calculatedColumnsEnum.BONUS_TOKEN_QUANTITY] || 0);

          dataTable[calculatedColumnsEnum.DIFF_ALL_TOKENS] =
            (data1[mesureEnum.PURCHASEHISTORY_TOKEN] || 0) +
            (data1[mesureEnum.PURCHASEHISTORY_BONUSTOKEN] || 0) +
            (data1[calculatedColumnsEnum.STAFF_CREDITED_TOKENS] || 0) -
            (totals2[calculatedColumnsEnum.TOKEN_QUANTITY] || 0) -
            (totals2[calculatedColumnsEnum.BONUS_TOKEN_QUANTITY] || 0);

          // Equivalent CA de la différence entre unités achetées et dépensées :
          // Correspond au total du CA Cartes vendues - équivalent CA des unités dépensées
          // ne doit pas inclure les achats snack par CB, mais REVENUE_TTC l'inclus déjà
          // => on l'ajoute aussi du côté du CA (PURCHASEHISTORY_AMOUNT + SNACKHISTORY_AMOUNT_CB_TTC) pour que ça s'annule
          dataTable[calculatedColumnsEnum.DIFF_REVENUE] =
            (data1[mesureEnum.PURCHASEHISTORY_AMOUNT] || 0) +
            (data1[mesureEnum.SNACKHISTORY_AMOUNT_CB_TTC] || 0) -
            (totals2[calculatedColumnsEnum.REVENUE_TTC] || 0);

          let updatedMeasureColumnsTable3 = null;
          if(dataTable[dimensionEnum.SITE_CURRENCY] !== undefined && dataTable[dimensionEnum.SITE_CURRENCY] != currencies["EUR"]){
            // here the site currency is not default EUROS
            // so we update this specific site's table header
            updatedMeasureColumnsTable3 = TableTools.Helper.updateCurrencyTableHeader(
              state.measureColumnsTable3,
              [calculatedColumnsEnum.DIFF_REVENUE],
              dataTable[dimensionEnum.SITE_CURRENCY]
            );
          }

          dispatch('updateTablesData', {
            tableNumber : tableNumberEnum.TABLE_THREE,
            siteId : site.id,
            dataTable : [dataTable],
            dynamicMeasureColumnsTable: updatedMeasureColumnsTable3
          });
        })

        commit('setDataReadyTables3', true);
      } catch (error) {
        Tools.Alerts.Error(Vue.swal, error)
      }
    },
	}
};
